import { render } from "./adminchatView.vue?vue&type=template&id=7e44f884&scoped=true"
import script from "./adminchatView.vue?vue&type=script&lang=js"
export * from "./adminchatView.vue?vue&type=script&lang=js"

import "./adminchatView.vue?vue&type=style&index=0&id=7e44f884&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e44f884"]])

export default __exports__